exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.exercise-footer button {\n  padding-left: 2em;\n  padding-right: 2em;\n  margin: 1ex;\n}\n.exercise-item .time {\n  float: right;\n}\n.exercise-header {\n  margin-bottom: 1em;\n}\n.enum {\n  counter-reset: item;\n}\n.enum > li {\n  display: table;\n  counter-increment: item;\n}\n.enum > li:before {\n  content: counters(item, \".\") \". \";\n  display: table-cell;\n}\n.enum_alph {\n  counter-reset: list;\n}\n.enum_alph > li {\n  list-style: none;\n}\n.enum_alph > li:before {\n  content: counter(list, lower-alpha) \") \";\n  counter-increment: list;\n}\n.bober-img {\n  width: auto;\n  height: auto;\n  max-width: 90%;\n  max-height: 90%;\n  margin: 20px;\n}\n.bober-table td {\n  padding: 5px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-43a34de4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exercises/Exercise.vue
// module id = 909
// module chunks = 1